export default {
   
  farm: {
    locationType: "Tipo de Localização",
    viewLocation: "Ver Localização",
    Circular: "Circular",
    Polygon: "Polígono",
    selectFarmToEnableCalenderView: "Selecione Farm para habilitar a visualização do calendário",
    farmActivities: "Atividades da fazenda",
    scheduledActivities: "Atividades Agendadas",
    completedActivities: "Atividades Concluídas",
    listView: "Visualização de lista",
    calendarView: "Visualização do Calendário",
    search: "Buscar",
    filterByFarmName: "Filtrar por Nome da Fazenda",
    filterByCropType: "Filtrar por Tipo de Cultura",
    filterByStartDate: "Filtrar por Data de Início",
    cropName: "Nome da Cultura",
    Name: "Nome",
    activities: "Atividades",
    startDate: "Data de Início",
    endDate: "Data de Término",
    activityDetails: "Detalhes da Atividade",
    customization: "Personalização",
    recordsPerpage: "Registros por Página",
    restoreDefault: "Restaurar Padrão",
    save: "Salvar",
    apply: "Aplicar",
    importFarmsInBulk: "Importar Fazendas em bloco",
    bulkImportNote: "Baixe e use os modelos abaixo para importar fazendas em bloco:",
    radius: "Raio",
    radiusInfo: "Especifica a distância de um ponto central à borda externa de uma área circular.",
    radiusUnitInfo: "Refere-se a uma quantidade padrão usada como base para a medição.",
    importFarms: "Importar fazendas a granel",
    importingNote: "Seu arquivo carregado está sendo processado.\nNão clique em cancelar, fechar ou atualizar esta página para evitar interrupções.",
    addFarm: "Adicionar Fazenda",
    importantNoteDetail: "Por favor, use os modelos fornecidos acima para uploads em massa. Outros formatos resultarão em falha.",
    importantNote: " Nota Importante",
    selectFileToUpload: "Selecione o arquivo para fazer upload",
    generateReport: "Gerar relatório",
    farmRegistration: "Registro de fazenda",
    farmInformation: "Informação da fazenda",
    iAmNotFarmer: "Eu não sou um produtor",
    farmID: "ID da Fazenda",
    farmId: "ID da Fazenda",
    farmIdPlaceHolder: "Farm id place holder" ,
    farmers: "Agricultores" ,
    farmName: "Nome da fazenda" ,
    nameOfTheFarm: "Nome da fazenda" ,
    farmRegistrationId: "Id de registro da fazenda" ,
    farmerRegistrationId: "Id de registro do agricultor" ,
    farmerFirstName: "Primeiro nome do agricultor" ,
    farmerMiddleName: "Nome do meio do agricultor" ,
    farmerLastName: "Sobrenome do agricultor" ,
    farmerId: "Id do agricultor" ,
    ownershipType: "Tipo de propriedade" ,
    certifications: "Certificações" ,
    productionType: "Tipo de produção" ,
    farmTitleDocument: "Documento de título da fazenda" ,
    dropHere: "ou arraste e solte aqui" ,
    farmLocationSize: "Tamanho da localização da fazenda" ,
    farmStateInfo: "Informações do estado da fazenda" ,
    farmLocationAddressInfo: "Informações do endereço da localização da fazenda" ,
    pleaseClickToChooseLocation: "Por favor clique para escolher localização" ,
    country: "País" ,
    countryH: "País h" ,
    provinceState: "Estado/Província" ,
    provinceStateInfo: "Informações do estado província" ,
    cityInfo: "Informações da cidade" ,
    streetNumber: "Número da rua" ,
    streetNumberInfo: "Informações do número da rua" ,
    addGeofenceForThisFarm: "Adicionar polígono para esta fazenda" ,
    useGeoFencingFeature: "Usar recurso de delimitação da fazenda" ,
    uploadShapeFile: "Carregar polígono da fazenda" ,
    cancel: "Cancelar",
    register: "Registrar",
    goals: "Objetivos",
    dashboard: "Painel",
    farms: "Fazendas",
    registerAfarm: "Registre uma fazenda",
    farmLocationAddress: "Endereço da localização da fazenda",
    city: "Cidade",
    streetNo: "Número da rua",
    "UPDATEGEOFENCEFORTHISFARM": "ATUALIZAR GEOFENCE PARA ESTA FARMACIA",
    "AddZonestothisfarm": "Adicionar zonas para esta fazenda",
    "ViewZonestothisfarm": "Ver zonas para esta fazenda",
    farmInfo: "Informações da fazenda",
    locationAndSize: "Localização e tamanho",
    farmReports: "Relatórios da fazenda",
    editFarm: "Editar fazenda",
    deleteFarm: "Excluir fazenda",
    basicInformation: "Informações básicas",
    primaryGeofence: "Geocerca primária",
    geofenceName: "Nome da geocerca",
    geofenceCategoryName: "Nome da categoria da geocerca",
    farmLocation: "Localização da fazenda",
    address: "Endereço",
    latitude: "Latitude",
    longitude: "Longitude",
    areaUnit: "Unidade de área",
    confirmation: "Confirmação", 
    saveAndConfirmationMessage: "Tem certeza de que deseja salvar as alterações?",
    confirmDownload: "Deseja baixar todos os anexos em formato PDF?",
  
    selectProductionPlacesUsingLots: "Selecione os locais de produção usando lotes",
    SelectProductionPlacesUsingFarms: "Selecione os locais de produção usando fazendas",
  
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "De acordo com o EUDR, fazendas com menos de 4 hectares não exigem um polígono.",
    circularAreaEquivalent: "Nesses casos, usaremos uma área circular equivalente ao tamanho da fazenda, com o ponto GPS fornecido como centro para verificar o desmatamento. Quando o tamanho da fazenda não for fornecido, usaremos 4 hectares por padrão.",
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow: "Se as fazendas forem menores, insira o tamanho padrão no campo abaixo.",
    defaultCircularGeofence: "Fazendas sem geofence ou sem informações sobre seu tamanho receberão um geofence circular padrão de 4 hectares. Se o tamanho médio da fazenda for menor que 4 hectares, altere o tamanho padrão clicando no botão 'Editar' abaixo.",
    defaultAreaValueSpecified: "Fazendas sem geofence ou área receberão o valor de área padrão especificado abaixo e serão atribuídas a um geofence de ponto com raio circular.",
    uploadFileBeingProcessed: "Seus arquivos carregados estão sendo processados. Você será redirecionado para a página de lista de relatórios de due diligence para ver o status.",
    processingLocations: "Processando Locais",
  
    lotId: "ID do Lote",
    product: "Produto",
    qualityGade: "Grau de Qualidade",
    processingDate: "Data de Processamento",
  
    importProductionPlaceTT: "Permite aos usuários importar dados do local de produção usando opções de upload ou download de arquivos.",
    internalReferenceNumberTT: "Um número de referência ou código utilizado internamente para organizar e gerenciar relatórios de due diligence.",
  
    onlyShowFarmsWithIssues: "Mostrar apenas fazendas com problemas",
    searchFarmName: "Buscar pelo Nome da Fazenda",
    pleaseSelectFarmType: "Por favor selecione o tipo de Fazenda",
    deforestationReports: "Relatório(s) de Desmatamento",
    stateStatement: "Região do país onde a fazenda está localizada.",
    countryState: "País onde a fazenda está localizada.",
    cityStatement: "Cidade onde a fazenda está localizada.",
    farmAddress: "Endereço da Localização da Fazenda",
    farmNumber: "Número da Fazenda",
    primaryLocation: "Localização Primária",
    addNewLocation: "Adicionar Nova Localização",
    totalFarmSize: "Tamanho Total da Fazenda",
    addNewZone: "Adicionar Nova Zona",
    locationZone: "Zona de Localização",
    noZoneMessage: "Nenhuma zona foi registrada ainda.",
    noZoneRequest: "Por favor, clique em Adicionar Nova Zona para criar uma zona para esta fazenda.",
    farmOwnershipType: "Tipo de Propriedade do Agricultor",
    farmGoals: "Objetivos da Fazenda",
    farmCertifications: "Certificações da Fazenda",
    enterHere: "Insira aqui",
    farmerName: "Nome do Agricultor",
    personal: "Pessoal",
    community: "Comunidade",
    farmType: "Tipo de Fazenda",
    "organic": "Orgânico",
    "conventional": "Convencional",
    
  technicianName: "Nome do técnico",
  regBy: "Registrado por",
  regDate: "Data de registro",
  geographicLocation: "Localização geográfica",
  searchLocation: "Procurar localização",
  pleaseChooseOneOfTheOption: "Por favor escolha uma das opções",
  uploadGeofence: "Carregar geocerca",
  upload: "Carregar",
  reports: "Relatórios",
  avocado: "Abacate",
  avocadoTrees: "Árvores de abacate",
  addNewFarmLocation: "Adicionar nova localização da fazenda",
  useGeofenceTool: "Usar ferramenta de geocerca",
  geofenceIsRequiredForSatelliteReport: "Nota: A geocerca é necessária para relatórios de satélite",
  secondaryLocation: "Localização secundária",
  editFarmLocation: "Editar localização da fazenda",
  addZone: "Adicionar zona",
  nameOfTheZone: "Nome da zona",
  zoneDetails: "Detalhes da zona",
  perimeter: "Perímetro",
  area: "Área",
  zoneName: "Nome da zona",
  farmGeofence: "Geocerca da fazenda",
  circularGeofence: "Geocerca circular",
  polygonGeofence: "Geocerca poligonal",
  actions: "Ações",
  editZone: "Editar zona",
  numberOfGroups: "Número de grupos",
  numberOfTrees: "Número de árvores",
  group: "Grupo",
  groupName: "Nome do grupo",
  numberOfAnimals: "Número de animais",
  status: "Status",
  walkAndMeasure: "Caminhar e medir",
  clearGeofence: "Limpar geocerca",
  deleteSelectedVertex: "Excluir vértice selecionado",
  farmRadius: "Raio da fazenda",
  locationDisabledMessage: "Sua localização está desativada. Por favor, procure sua localização nos menus à esquerda.",
  yourDistanceIs: "Sua distância é",
  selectFarmToEnableCalendarView: "Por favor, selecione uma fazenda para habilitar a visualização do calendário",
  noFarm: "Nenhuma fazenda foi registrada ainda.",
  noFarmDescription: "Por favor, clique nos botões abaixo para começar.",
  },


  plantation: {
    farmerName: "Nome do agricultor",
    phoneNumber: "Número de telefone",
    plantationName: "Nome da plantação",
    farm: "Propriedade",
    location: "Localização",
    updatePlantationStatus: "Atualizar Status da Plantação",
    update: "Atualizar",
  },
}